export default [{
    path: '/admin/mechanism/home',
    name: 'MechanismHome',
    component: () => import('@/views/mechanism/home'),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/admin/mechanism/config/platform',
    name: 'Mechanismplatform',
    component: () => import('@/views/mechanism/config/platform'),
    meta: {
      title: '平台设置'
    }
  },
  {
    path: '/admin/mechanism/authority/account_number',
    name: 'MechanismAuthorityAccountNumber',
    component: () => import('@/views/mechanism/authority/account_number'),
    meta: {
      title: '权限-账号列表'
    }
  },
  {
    path: '/admin/mechanism/authority/role',
    name: 'MechanismAuthorityRole',
    component: () => import('@/views/mechanism/authority/role'),
    meta: {
      title: '权限-角色列表'
    }
  },
  {
    path: '/admin/mechanism/authority/organization',
    name: 'MechanismAuthorityOrganization',
    component: () => import('@/views/mechanism/authority/organization'),
    meta: {
      title: '权限-机构列表'
    }
  },
  {
    path: '/admin/mechanism/user/list',
    name: 'MechanismUserList',
    component: () => import('@/views/mechanism/user/list'),
    meta: {
      title: '用户列表'
    }
  },
  {
    path: '/admin/mechanism/device_list/device_list',
    name: 'MechanismDeviceList',
    component: () => import('../views/mechanism/device_list/device_list'),
    meta: {
      title: '设备-设备列表',
      keepAlive: true,
    }
  },
  {
    path: '/admin/mechanism/device_list/device_details',
    name: 'DeviceDetails',
    component: () => import('../views/mechanism/device_list/device_details'),
    meta: {
      title: '设备-设备详情'
    }
  },
  {
    path: '/admin/mechanism/fence_management/fence_management',
    name: 'FenceManagement',
    component: () => import('../views/mechanism/fence_management/fence_management'),
    meta: {
      title: '设备-围栏管理'
    }
  },
  {
    path: '/admin/mechanism/device_map/device_map',
    name: 'MechanismDeviceMap',
    component: () => import('../views/mechanism/device_map/device_map'),
    meta: {
      title: '设备-设备地图'
    }
  },
  {
    path: '/admin/mechanism/police_management/police_list',
    name: 'PoliceList',
    component: () => import('../views/mechanism/police_management/police_list'),
    meta: {
      title: '设备-报警记录'
    }
  },
  {
    path: '/admin/mechanism/police_management/alarm_scheme',
    name: 'AlarmScheme',
    component: () => import('../views/mechanism/police_management/alarm_scheme'),
    meta: {
      title: '设备-告警方案',
    }
  },
  {
    path: '/admin/mechanism/medicineChest/Index',
    name: 'MechanismMedicineChestIndex',
    component: () => import('../views/mechanism/medicineChest/index'),
    meta: {
      title: '设备-商品管理'
    }
  },
  {
    path: '/admin/mechanism/config/data_large_screen',
    name: 'ConfigDataLargeScreen',
    component: () => import('../views/device/data_large_screen'),
    meta: {
      title: '设备-数据大屏设置'
    }
  },
  {
    path: '/admin/mechanism/sleep_detection/real_time_data',
    name: 'SleepDetectionRealTimeData',
    component: () => import('../views/device/mqtt/realTimeData'),
    meta: {
      title: '设备-实时数据'
    }
  },
  {
    path: '/admin/mechanism/sleep_detection/statement',
    name: 'SleepDetectionStatement',
    component: () => import('../views/device/mqtt/statement'),
    meta: {
      title: '设备-睡眠报告'
    }
  },
  {
    path: '/admin/mechanism/service/list',
    name: 'MechanismServiceList',
    component: () => import('../views/user/service/list'),
    meta: {
      title: '服务列表'
    }
  },
  {
    path: '/admin/mechanism/service/dtl',
    name: 'ServiceDtl',
    component: () => import('../views/user/service/dtl'),
    meta: {
      title: '服务详情'
    }
  },
  {
    path: '/admin/mechanism/service/policeList',
    name: "ServicePoliceList",
    component: () => import('@/views/user/service/policeList'),
    meta: {
      title: '接警联系人'
    }
  },
  {
    path: '/admin/mechanism/user/dtl',
    name: 'UserDtl',
    component: () => import('@/views/mechanism/user/dtl'),
    meta: {
      title: '用户详情'
    }
  },
  {
    path: '/admin/mechanism/device/aotong',
    name: 'AoTong',
    component: () => import('@/views/device/aotong/list'),
    meta: {
      title: '跌倒报警器'
    }
  },
  {
    path: '/admin/mechanism/shop/goods_list',
    component: () => import('@/views/goods/list'),
    meta: {
      title: '商城-商品列表'
    }
  },
  {
    path: '/admin/mechanism/shop/goods_edit',
    component: () => import('@/views/goods/edit'),
    meta: {
      title: '商城-商品编辑'
    }
  },
  {
    path: '/admin/mechanism/shop/order_list',
    component: () => import('@/views/mechanism/shop/order_list'),
    meta: {
      title: '商城-订单列表'
    }
  },
  {
    path: '/admin/mechanism/shop/order_dtl',
    component: () => import('@/views/order/order_details'),
    meta: {
      title: '商城-订单详情'
    }
  },
  {
    path: '/admin/mechanism/shop/frieghtlist',
    component: () => import('@/views/config/frieghtlist'),
    meta: {
      title: '商城-运费规则'
    }
  },
  {
    path: '/admin/mechanism/shop/frieghtedit',
    component: () => import('@/views/config/frieghtedit'),
    meta: {
      title: '商城设置-编辑运费规则'
    }
  },
  {
    path: '/admin/mechanism/shop/coupon',
    component: () => import('@/views/coupon/list'),
    meta: {
      title: '商品-优惠券'
    }
  },
  {
    path: '/admin/mechanism/shop/category',
    component: () => import('@/views/goods/category'),
    meta: {
      title: '商品-分类'
    }
  },
  {
    path: '/admin/mechanism/shop/writeOffList',
    component: () => import('@/views/shop/verifier/index'),
    meta: {
      title: '商品-师傅列表'
    }
  },
  {
    path: '/admin/mechanism/record/list',
    name: "MechanismRecordList",
    component: () => import('@/views/user/record/list'),
    meta: {
      title: '档案列表'
    }
  },
  {
    path: '/admin/mechanism/record/details',
    name: "MechanismRecordDetails",
    component: () => import('@/views/user/record/details'),
    meta: {
      title: '档案信息'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/mechanism.js